import React from "react";
import { Route, Navigate } from "react-router-dom";
import MenuPage from "./components/QrMenuPage";
import AdminPanelFirebase from "./components/AdminPanelFirebase";
import LoginForm from "./components/LoginForm";
import QrMenuTvPage from "./components/QrMenuTvPage/QrMenuTvPage";
import TvVideoPage from "./components/TvVideoPage/TvVideoPage";
import Aboute from "./pages/Aboute/Aboute";
import Contact from "./pages/Contact/Contact";


const ADMIN_EMAIL = "admin@pascali.com";

export const getRoutes = (user) => [
  <Route key="/" path="/" element={<MenuPage />} />,
  <Route key="/tv-menu" path="/tv-menu" element={<QrMenuTvPage />} />,
  <Route key="/tv-video" path="/tv-video" element={<TvVideoPage />} />,
  <Route key="/about" path="/about" element={<Aboute />} />,
  <Route key="/contact" path="/contact" element={<Contact />} />,

  <Route
    key="/admin"
    path="/admin"
    element={
      user?.email === ADMIN_EMAIL ? (
        <AdminPanelFirebase />
      ) : (
        <LoginForm />
      )
    }
  />,
  <Route key="*" path="*" element={<Navigate to="/" />} />,
];
